import { EventType } from '@/types/projects.types';
import {
  ESessionFeatures,
  EventDefaultFeatures,
  OnDemandDefaultFeatures,
  TownhallDefaultFeatures,
  TSessionFeatureListItem,
  WebinarDefaultFeatures,
} from '@/types/session-features.types';

type TDefaultFeatureOptions = {
  disabledFeatures?: Set<ESessionFeatures>;
};

export const getDefaultFeaturesByProjectType = (
  projectType?: EventType,
  options?: TDefaultFeatureOptions
): TSessionFeatureListItem[] => {
  const disabledFeatures = options?.disabledFeatures || new Set();
  let features = EventDefaultFeatures;

  if (projectType === EventType.Townhall || projectType === EventType.Allhands) {
    features = TownhallDefaultFeatures;
  }
  if (projectType === EventType.Webinar) {
    features = WebinarDefaultFeatures;
  }
  if (projectType === EventType.OnDemand) {
    features = OnDemandDefaultFeatures;
  }

  if (disabledFeatures.size > 0) {
    features = features.filter((feature) => !disabledFeatures.has(feature.value));
  }

  return features;
};
